import { hashString } from './sampleMock';

/**
 * Stable reference for a question across server requests (src/server/quizCore.js).
 * Rows keep their id; rows without one (tagged drill rows) get a content hash.
 * Level-prefixed so an L2 id is never looked up in the L1 bank.
 */
export function itemRef(level, q) {
  const lv = level === 'l2' || level === 'l3' ? level : 'l1';
  const id = q?.id != null && String(q.id).trim() !== '' ? String(q.id) : '';
  if (id) return `${lv}:${id}`;
  const body = `${String(q?.question || '').trim()}\u0000${JSON.stringify(q?.options || [])}`;
  return `${lv}:h-${hashString(body).toString(16)}`;
}
